// extracted by mini-css-extract-plugin
module.exports = {"productPerPageWrapper":"ProductsPerPage_productPerPageWrapper___0U26"};